/* eslint-disable @typescript-eslint/no-unsafe-assignment */
//import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
//import { Avatar, Card, CardContent, CardHeader, CircularProgress, Grid } from '@mui/material';

import { Card, CardContent, CircularProgress, Grid } from "@mui/material"
import { useSelector } from "react-redux"

import { useTranslation } from "react-i18next"
import { ReactComponent as AdventureSvg } from "../../assets/img/adventure.svg"
import { ReactComponent as BanksSvg } from "../../assets/img/banks.svg"
import { ReactComponent as DeniedSvg } from "../../assets/img/denied.svg"
import { ReactComponent as MistakeSvg } from "../../assets/img/mistake.svg"
import { ReactComponent as SyncSvg } from "../../assets/img/sync.svg"
import { ReactComponent as TeamSvg } from "../../assets/img/team.svg"
import { RootState } from "../../store"
import {
	UserStatisticsData,
	UserStatisticsState,
} from "../../store/actions/statistics"

const UserStatistics = () => {
	const { t } = useTranslation()
	const banksList = useSelector((state: RootState) => state.banksUser?.list)
	const userStatisticsState: UserStatisticsState = useSelector(
		(state: RootState) => state.statistics.user
	)
	const statisticsData = userStatisticsState?.data?.reduce(
		(
			accumulator: {
				totalUser: number
				totalUserEnabled: number
				totalUserDisabled: number
				totalUserNeverLogged: number
				totalFailedLogin: number
			},
			userStat: UserStatisticsData
		) => {
			return {
				totalUser:
					(accumulator.totalUser ?? 0) +
					(userStat?.enabled ?? 0) +
					(userStat?.disabled ?? 0),
				totalUserEnabled:
					(accumulator.totalUserEnabled ?? 0) + (userStat?.enabled ?? 0),
				totalUserDisabled:
					(accumulator.totalUserDisabled ?? 0) + (userStat?.disabled ?? 0),
				totalUserNeverLogged:
					(accumulator.totalUserNeverLogged ?? 0) +
					(userStat?.neverLogged ?? 0),
				totalFailedLogin:
					(accumulator.totalFailedLogin ?? 0) +
					(userStat?.userWithFailedLogin ?? 0),
			}
		},
		{
			totalUser: 0,
			totalUserEnabled: 0,
			totalUserDisabled: 0,
			totalUserNeverLogged: 0,
			totalFailedLogin: 0,
		}
	)

	const CardNeverLoggedUser = () => {
		return (
			statisticsData && (
				<Grid container gap={"16px"}>
					<Grid item>
						<AdventureSvg width={"90px"} height={"90px"} />
					</Grid>
					<Grid item>
						<Grid
							container
							flexDirection={"column"}
							sx={{
								justifyContent: "space-around",
								height: "100%",
								alignItems: "center",
							}}
						>
							<Grid item sx={{ fontSize: "24px" }}>
								{statisticsData?.totalUserNeverLogged}
							</Grid>
							<Grid
								item
								sx={{
									fontSize: "14px",
									fontWeight: "bold",
									marginBottom: "16px",
								}}
							>
								{t("card.user.noAccess", { ns: "dashboard" })}
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			)
		)
	}

	const CardFailedLoginUser = () => {
		return (
			statisticsData && (
				<Grid container>
					<Grid item>
						<MistakeSvg width={"90px"} height={"90px"} />
					</Grid>
					<Grid item>
						<Grid
							container
							flexDirection={"column"}
							sx={{
								justifyContent: "space-around",
								height: "100%",
								alignItems: "center",
							}}
						>
							<Grid item sx={{ fontSize: "24px" }}>
								{statisticsData?.totalFailedLogin}
							</Grid>
							<Grid
								item
								sx={{
									fontSize: "14px",
									fontWeight: "bold",
									marginBottom: "16px",
								}}
							>
								{t("card.user.failed", { ns: "dashboard" })}
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			)
		)
	}

	const CardTotalUser = () => {
		return (
			statisticsData && (
				<Grid container>
					<Grid item>
						<TeamSvg width={"90px"} height={"90px"} />
					</Grid>
					<Grid item>
						<Grid
							container
							flexDirection={"column"}
							sx={{
								justifyContent: "space-around",
								height: "100%",
								alignItems: "center",
							}}
						>
							<Grid item sx={{ fontSize: "24px" }}>
								{statisticsData && statisticsData?.totalUser}
							</Grid>
							<Grid
								item
								sx={{
									fontSize: "14px",
									fontWeight: "bold",
									marginBottom: "16px",
								}}
							>
								{t("card.user.total", { ns: "dashboard" })}
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			)
		)
	}

	const CardDeniedUser = () => {
		return (
			statisticsData && (
				<Grid container>
					<Grid item>
						<DeniedSvg width={"90px"} height={"90px"} />
					</Grid>
					<Grid item>
						<Grid
							container
							flexDirection={"column"}
							sx={{
								justifyContent: "space-around",
								height: "100%",
								alignItems: "center",
							}}
						>
							<Grid item sx={{ fontSize: "24px" }}>
								{statisticsData?.totalUserDisabled}
							</Grid>
							<Grid
								item
								sx={{
									fontSize: "14px",
									fontWeight: "bold",
									marginBottom: "16px",
								}}
							>
								{t("card.user.disabled", { ns: "dashboard" })}
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			)
		)
	}

	const CardBanksUser = () => {
		return (
			statisticsData && (
				<Grid container>
					<Grid item>
						<BanksSvg width={"90px"} height={"90px"} />
					</Grid>
					<Grid item>
						<Grid
							container
							flexDirection={"column"}
							sx={{
								justifyContent: "space-around",
								height: "100%",
								alignItems: "center",
							}}
						>
							<Grid item sx={{ fontSize: "24px" }}>
								{banksList?.length}
							</Grid>
							<Grid
								item
								sx={{
									fontSize: "14px",
									fontWeight: "bold",
									marginBottom: "16px",
								}}
							>
								{t("card.user.banks", { ns: "dashboard" })}
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			)
		)
	}

	return userStatisticsState.isLoading ? (
		<Grid
			container
			flexDirection="column"
			sx={{ width: "100%", alignItems: "center" }}
		>
			<Grid item>
				<SyncSvg style={{ width: "250px" }} />
			</Grid>
			<Grid item>
				<Grid
					container
					flexDirection="column"
					sx={{ width: "100%", alignItems: "center" }}
				>
					<Grid item>
						<CircularProgress color="secondary" />
					</Grid>
					<Grid item>
						{t("loading.title", { ns: "dashboard" })}
						<br /> {t("loading.subtitle", { ns: "dashboard" })}
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	) : (
		<Grid container gap={"8px 16px"}>
			<Grid item>
				<Card
					sx={{
						borderRadius: ".25rem",
						boxShadow: "0 0 .875rem 0 rgba(52, 58, 64, .05)",
					}}
				>
					<CardContent>
						<CardTotalUser />
					</CardContent>
				</Card>
			</Grid>
			<Grid item>
				<Card
					sx={{
						borderRadius: ".25rem",
						boxShadow: "0 0 .875rem 0 rgba(52, 58, 64, .05)",
					}}
				>
					<CardContent>
						<CardDeniedUser />
					</CardContent>
				</Card>
			</Grid>
			<Grid item>
				<Card
					sx={{
						borderRadius: ".25rem",
						boxShadow: "0 0 .875rem 0 rgba(52, 58, 64, .05)",
					}}
				>
					<CardContent>
						<CardFailedLoginUser />
					</CardContent>
				</Card>
			</Grid>
			<Grid item>
				<Card
					sx={{
						borderRadius: ".25rem",
						boxShadow: "0 0 .875rem 0 rgba(52, 58, 64, .05)",
					}}
				>
					<CardContent>
						<CardNeverLoggedUser />
					</CardContent>
				</Card>
			</Grid>
			{banksList?.length > 1 && (
				<Grid item>
					<Card
						sx={{
							borderRadius: ".25rem",
							boxShadow: "0 0 .875rem 0 rgba(52, 58, 64, .05)",
						}}
					>
						<CardContent>
							<CardBanksUser />
						</CardContent>
					</Card>
				</Grid>
			)}
		</Grid>
	)
}

export default UserStatistics
